/**
 * Provides icon components.
 */
import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import faIconSet from 'assets/fonts/font-awesome.json';
import { VectorIcon, VectorIconProps } from './vectorIcons';

export const NakedIcon = ({ children, ...props }: VectorIconProps) => {
  const [config, setConfig] = useState<unknown>();

  useEffect(() => {
    import('assets/fonts/naked-icons.json').then(nakedIconSet => {
      setConfig(nakedIconSet.default);
    });
  }, []);

  return config ? (
    <VectorIcon config={config as never} {...props}>
      {children}
    </VectorIcon>
  ) : null;
};
/**
 * Retrieves the font configuration for a given icon by its name.
 *
 * @param iconName - The name of the icon i.e. `fa-heart`.
 * @returns An Icon configuration.
 */
async function getIconConfig(iconName: string) {
  const splitIndex = iconName.indexOf('-');
  const prefix = iconName.substring(0, splitIndex);
  const name = iconName.substring(splitIndex + 1);
  const nakedIconSet = (await import('assets/fonts/naked-icons.json')).default;

  switch (prefix) {
    case 'fa':
      return {
        config: faIconSet,
        family: 'FontAwesome',
        name,
      };
    case 'ion':
    case 'mui':
    case 'zocial':
    default:
      return {
        config: nakedIconSet,
        name,
      };
  }
}
/**
 * Return a function component that loads the appropriate Vector Icon.
 *
 * @param name - Name of the icon.
 * @param customProps - Additional props to customise the icon.
 */
export function loadIcon(name: string, customProps?: VectorIconProps): typeof VectorIcon {
  class CustomLoadedIcon extends VectorIcon {
    state = { config: null };
    public componentDidMount() {
      getIconConfig(name).then(config => {
        this.setState(config);
      });
    }
    public render() {
      const props = { ...this.state, ...this.props, ...customProps };

      return this.state.config ? <VectorIcon {...props} /> : null;
    }
  }

  return CustomLoadedIcon;
}
export const ErrorCloseIcon = styled(NakedIcon)`
  align-content: center;
  color: red;
  padding: 8px;
  padding-right: 12;
  text-align: center;
`;
